import {
  AccountingConnectionPartner,
  AccountingConnectionSyncState,
  ListAccountingConnectionsFilterParameterStatusEq
} from "@wingspanhq/wingspan-api-sdk";
import { queriesAccountingConnections } from "@query";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import React, { useState } from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useQueriesOn } from "../../../shared/hooks/useQueriesOn";

export const QuickbooksWrapper: React.FC = props => {
  // the list filter only accepts `status` — partner is narrowed below
  const qAccountingConnections =
    queriesAccountingConnections.listAccountingConnections.useQuery({});
  const qFeatureFlags = useQueryFeatureFlags();
  const [render, setRender] = useState(false);

  useQueriesOn(
    "successAll",
    () => {
      setTimeout(() => setRender(true), 100);
    },
    qAccountingConnections,
    qFeatureFlags
  );

  return (
    <WSQueries
      queries={{
        qAccountingConnections,
        qFeatureFlags
      }}
      renderErrors={() => null}
      renderLoader={() => null}
    >
      {({ qAccountingConnections, qFeatureFlags }) => {
        const hasSyncedConnection = (
          qAccountingConnections.data.data || []
        ).some(
          connection =>
            connection.partner === AccountingConnectionPartner.QUICKBOOKS &&
            connection.status ===
              ListAccountingConnectionsFilterParameterStatusEq.CONNECTED &&
            connection.syncState === AccountingConnectionSyncState.SYNCED
        );

        const isQuickbooksActive =
          qFeatureFlags.data.qboOnboarding &&
          (qFeatureFlags.data?.forceShowQBO || hasSyncedConnection);

        if (render && isQuickbooksActive) {
          return <>{props.children}</>;
        }

        return null;
      }}
    </WSQueries>
  );
};
